import React from 'react';

import H2 from 'apps/Pdf/components/common/H2';

import { sqlDateToLabel, formatAmount, formatNumber } from 'helpers/helpers';
import useTableStyles from 'apps/Pdf/styles/tables';
import useGeneralStyles from 'apps/Pdf/styles/general';
import { CurrencyHedgingInstrumentsData } from '../StatementInterface';
import { AmountValue } from 'common/interfaces';
import { Currency } from 'enums';

interface Props {
  data: CurrencyHedgingInstrumentsData[];
  currency: Currency;
  total: AmountValue;
}

const CurrencyHedgingInstrumentsTable = (props: Props) => {
  const styles = useGeneralStyles();
  const tables = useTableStyles();
  const { data, total } = props;

  return (
    <>
      {data.length ? (
        <>
          <H2>Nástroje měnového zajištění</H2>
          <table className={`${tables.root} ${tables.overview} ${tables.transactions}`}>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>Instrument</th>
                <th>Pozice</th>
                <th>Datum splatnosti</th>
                <th>Aktuální kurz</th>
                <th>Forwardový kurz</th>
                <th>Nerealizovaný zisk/ztráta</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={`instrument_${item.instrument}`} className={styles.value}>
                  <td className="T2">&nbsp;</td>
                  <td>{item.instrument}</td>
                  <td>{formatNumber(item.position, 2)}</td>
                  <td>{sqlDateToLabel(item.maturityDate, 'd. M. yyyy')}</td>
                  <td>{formatNumber(item.currentExchangeRate, 4)}</td>
                  <td>{formatNumber(item.forwardExchangeRate, 4)}</td>
                  <td>{formatAmount(item.unrealizedProfit, props.currency)}</td>
                </tr>
              ))}
              {total && (
                <tr className="sum">
                  <td>&nbsp;</td>
                  <td colSpan={5}>Celkem</td>
                  <td>{formatAmount(total, props.currency)}</td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      ) : null}
    </>
  );
};

export default CurrencyHedgingInstrumentsTable;
